<template>
    <div class="h-full">
        <div v-if="!isMobile" class="bg-center bg-cover h-full relative" :style="displayCockfightBackground ? `background-image: url(${displayCockfightBackground})` : ''">
            <MerchantMarqueeAnnounce></MerchantMarqueeAnnounce>
            <div class="container">
                <div class="relative py-5">
                    <img class="cockfight_img" alt="cockfight_img" :src="$pub('/img/cockfight_img.webp')" />
                    <div v-if="gamesStore.cockfight.ready" class="relative game_box">
                        <div v-if="mainStore.loadingGame" class="loading_bg !z-20">
                            <Spinner></Spinner>
                        </div>
                        <div v-for="(l, index) in gameList" :key="index" class="relative" :class="dashboardStore.maintenanceData[l[0].provider_id] ? 'maintenance' : ''">
                            <button type="button" class="btn_cockfight" :aria-label="`${l[0].type}_${l[0].provider_name}_GAME`">
                                <div class="btn_cockfight_aspect_ratio"></div>
                                <img @click="playGame(l[0])" :src="getProviderLogo(l[0].provider_name)" :alt="`${l[0].type}_${l[0].provider_name}_GAME`"/> 
                            </button>
                            <div v-if="dashboardStore.maintenanceData[l[0].provider_id]" class="maintenance_box">
                                <div class="maintenance_text">
                                    <div class="maintenance_text_1">
                                        <span v-if="dashboardStore.maintenanceData[l[0].provider_id].end_date != '-'">{{ $t('maintenance_note', {start_date: dashboardStore.maintenanceData[l[0].provider_id].start_date, end_date: dashboardStore.maintenanceData[l[0].provider_id].end_date})}}</span>
                                        <span v-else>{{ $t('maintenance_note_2', {start_date: dashboardStore.maintenanceData[l[0].provider_id].start_date})}}</span>
                                    </div>
                                    <div class="maintenance_text_2">[{{l[0].provider_name}}]</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="relative game_box">
                        <div class="w-full h-[200px] skeleton"></div>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="isMobile">
		    <MerchantGameContainerMobile v-if="config.public?.IS_NORMAL_SPORT_PAGE" type="cockfight"></MerchantGameContainerMobile>
            <div v-else class="overflow-y-auto h-[calc(100vh-var(--offset))] supports-[height:100dvh]:h-[calc(100dvh-var(--offset))]" style="--offset:130px;">
                <MerchantHomeGameContainerMobile category="cockfight" :hideMenu="true"></MerchantHomeGameContainerMobile>
            </div>
        </template>
    </div>
</template>


<script setup>
const { isMobile } = useDevice();
const config = useRuntimeConfig();
const mainStore = useMainStore();
const gamesStore = useGamesStore();
const userStore = useUserStore();
const dashboardStore = useDashboardStore();
const providerStore = useProviderStore();
const { $pub, $resolveUrl } = useNuxtApp()
const { locale, locales } = useI18n()

const readyWatcher = watchEffect(() => {
    if (providerStore.ready && (!userStore.loggedIn || (userStore.loggedIn && dashboardStore.ready))) {
        gamesStore.getGames('cockfight')
        readyWatcher()
    }
}, {
    flush: 'post'
})

watch(() => userStore.loggedIn, () => {
    gamesStore.getGames('cockfight')
})

const playGame = (e) => {
    var game = {
        provider_name: e.provider_name,
        currency: dashboardStore.data.currency,
        provider_id: e.provider_id,
        game_id: e.game_id,
        maintenance: dashboardStore.maintenanceData[e.provider_id]
    }
    gamesStore.playGame(game);
}

const gameList = computed(() => {
    if (!providerStore.ready || !gamesStore["cockfight"].ready) {
        return {}
    }
    if (!gamesStore["cockfight"]) {
        return {}
    }
    
    let allGames = gamesStore["cockfight"].list;
    delete allGames.ALL;
    return allGames;
})

const getProviderLogo = (p) => {
	if (p) {
        return $resolveUrl(`{d}game/games/cockfight/${p.toUpperCase()}/GAME.webp`);
	} else {
		return $pub('/img/logo.png');
	}
}

const displayCockfightBackground = computed(() => {
    return $pub('/img/bg_cockfight.webp');
})
</script>

<style scoped>
.cockfight_img {
    width: 600px;
    position: relative;
    margin: 0 auto;
}

.game_box {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: -150px;
}


.btn_cockfight {
    width: 200px;
    position: relative;
    margin: 10px;
}

.btn_cockfight .btn_cockfight_aspect_ratio {
    width: 100%;
    padding-top: 100%;
}

.btn_cockfight img {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(1);
    transition: all 0.3s;
}

.isDesktop .btn_cockfight:hover img {
    transform: translate(-50%, -50%) scale(1.1);
}

@media (max-width: 767px) {
    .cockfight_img {
        width: 100%;
    }
    .game_box {
        margin-top: -100px;
    }
    .btn_cockfight {
        width: 100px;
    }
}
</style>